import { useVehicleBrand } from '@services/option'
import { Select, SelectProps } from '@shared/Form/Select'
import { useTranslation } from 'react-i18next'

export default function VehicleBrandSelect(props: SelectProps) {
  const { t } = useTranslation()

  const { dataSource, loading } = useVehicleBrand()

  return (
    <Select
      {...props}
      allowClear
      showSearch
      placeholder={t('option:vehicleBrand')}
      loading={loading}
      options={dataSource?.content?.map((i: any) => ({
        value: i.code,
        label: i.code,
      }))}></Select>
  )
}
